import api from '../../store/config/api';
import { RUN_LIST as SCHEMA } from '../../schemas';
import { format } from '../../util/url';

export const [
  GET_RUNS,
  GET_RUNS_REQUEST,
  GET_RUNS_SUCCESS,
  GET_RUNS_FAILURE
] = api.buildTypes('GET_RUNS');

export function getRunList({
  search,
  teamName,
  assignedToMe,
  owner,
  status,
  includeChildren,
  limit,
  after,
  q,
  sort
}) {
  if (assignedToMe != null || includeChildren != null || search !== true) {
    // Use legacy endpoint for backwards compatibility.
    // This can be removed once we establish that the /search endpoint is stable enough for all traffic.
    const baseUrl = `/teams/${teamName}`;
    const pathname = assignedToMe
      ? `${baseUrl}/users/me/runs`
      : `${baseUrl}/runs`;
    const url = format({ pathname, query: { status, includeChildren } });

    return {
      type: GET_RUNS,
      payload: {
        url,
        schema: SCHEMA,
        options: {
          method: 'GET'
        }
      }
    };
  }

  const query = {
    types: 'runs'
  };
  if (status && status !== 'all') {
    query.status = status;
  }
  if (owner) {
    query.owner = owner;
  }
  if (limit) {
    query.limit = limit;
  }
  if (after) {
    query.pageToken = after;
  }
  if (q) {
    query.q = q;
  }
  if (sort) {
    query.sort = sort;
  }

  const url = format({
    pathname: `/teams/${teamName}/search`,
    query
  });

  return {
    type: GET_RUNS,
    payload: {
      url,
      schema: SCHEMA,
      options: {
        method: 'GET'
      }
    }
  };
}



// WEBPACK FOOTER //
// ./js/actions/api/runs.js